import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { Button } from 'components/atoms/button';
import { ProductiveHeading06 } from 'components/styles';
import { RoutePaths } from 'constant';
import { useTranslation } from 'hooks/use-translation';

const Container = styled.div`
  width: 100%;
  display: flex;
  min-height: 200px;
  align-items: center;
  justify-content: center;
  text-align: center;
  flex-direction: column;
`;

const Heading = styled.h6`
  ${ProductiveHeading06};
`;

export const GoToProjects: FC<{ onClick: () => void }> = ({ onClick }) => (
  <Container>
    <Heading>
      <FormattedMessage id="projects.empty" />
    </Heading>
    <Link to={RoutePaths.projects}>
      <Button type="link" onClick={onClick}>
        {useTranslation('projects.go_to')}
      </Button>
    </Link>
  </Container>
);
